<template>
  <div class="pc_pay">
    <div class="pay_main">
      <div class="left">
        <p>请使用微信 扫描二维码支付~~</p>
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <div class="right">
         <img src="./static/wxpay.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import http from '@/utils/http'
export default {
  data() {
    return {
      payUrl: 'http://www.baidu.com',
      ticket:null
    }
  },
  computed: {
    meetingId() {
        return this.$store.state.meetingId || localStorage.getItem('meetingId')
    }
  },
  mounted() {
    this.ticket = JSON.parse(localStorage.getItem('chooseTicket'))
    this.payUrl=localStorage.getItem('payurl')
    this.getPayUrl()
    
  },
  beforeRouteLeave(to,from,next){
      if(this.timeid) { //如果定时器还在运行 或者直接关闭，不用判断
          clearInterval(this.timeid); //关闭
      }

      next()
  },
  beforeDestroy() {
      if(this.timeid) { //如果定时器还在运行 或者直接关闭，不用判断
          clearInterval(this.timeid); //关闭
      }
  },
  methods: {
    async getAudienceMobile() {
        // alert('getAudienceMobile')
        const params = {
          mobile: this.$store.state.registerMobile
        }
        const res = await http.get(`/renren-fast/app/audienceCenter/getOrderAudienceMobile/${this.meetingId}`)
        console.log('111',res)
        if(res.code === 0) {
            const audienceIdAndMeetingId = {meetingId: this.meetingId,audienceId: res.audience.id}
            localStorage.setItem('audienceId', res.audience.id)
            localStorage.setItem('audienceIdAndMeetingId',JSON.stringify(audienceIdAndMeetingId))
        }
    },
    getPayUrl() {
      // 发送请求  获取支付地址

      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.payUrl, // 需要转换为二维码的内容
        width: 300,
        height: 300,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })

      // 开启循环
      this.timeid=setInterval(async ()=>{
            // /renren-fast/app/h5pay/getOrderStatus
            let url='/renren-fast/app/h5pay/getOrderStatus'
            let params={ openId: localStorage.getItem('openId'),orderNo: this.ticket.orderNo }
            if(this.$route.query.type==='hotel') {
                url = '/renren-fast/app/hotel/getOrderStatus'
                params = {orderNo: localStorage.getItem('hotelOrderNo')}
            }
            const res = await http.get('http://web.nmep.com.cn:8080' + url, {params})
            console.log('查询结果',res)
            if(res.code==0&&res.status=='SUCCESS'){
               console.log('支付成功！！')
                clearInterval(this.timeid); //关闭
                if  (this.$route.query.type==='hotel') {
                    this.$router.push('/pay_success')
                    return
                }
                // this.getAudienceMobile()
                this.$router.push('/pay_success?from=ticket')
            }else if(res.code==0&&res.status=='FAIL'){
               console.log('支付中！！')
              //  clearInterval(this.timeid); //关闭
            }else if(res.code==500){
              console.log('数据不存在！！')
               clearInterval(this.timeid); //关闭
            }
      },1000)

    }
  }
}
</script>

<style lang="stylus" scoped>
@media screen and (min-width: 800px) {
  .pc_pay {
    background-color: #fff;
    height: 100vh;

    .pay_main {
      display: flex;
      width: 700px;
      height: 500px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      // background-color: pink;

      >div {
        flex: 1;
      }
      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          width 100%
          text-align center
          padding 15px 0
          font-size 15px
          background-color #eb7e79
          margin-bottom 10px
          color #fff
        }
      }
      .right {
        padding: 0 30px;
        img {
          width:250px
        }
      }
    }
  }

  .qrcode {
    padding 10px
    border 1px solid #ccc
    width: 400px;
    height: 400px;
    display flex 
    justify-content center
    align-items center
    img {
      width: 400px;
      height: 400px;
      background-color: #fff; // 设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
    }
  }
}
</style>